import DownloadIcon from "@mui/icons-material/GetApp";
import { CircularProgress, Button as MuiButton } from "@mui/material";
import { 
  downloadCSV, 
  useDataProvider,
  useNotify 
} from "react-admin";
import { useState } from 'react';

const ExportButton = ({resource, sort, filterValues, filename}) => {
  const [loading, setLoading] = useState(false);
  const dataProvider = useDataProvider()
  const notify = useNotify();
  
  const handleClick = async () => {
    notify("Download started...")
    setLoading(true);

    const response = await dataProvider.getCSV(resource, {
        pagination: { page: 1, perPage: 1000000 },
        sort: sort || { field: 'id', order: 'DESC' },
        filter: filterValues || {},
    });

    downloadCSV(response.data, filename || resource);
    
    setLoading(false);
    notify('Download complete!')
  }
  
  

  return (
    <MuiButton
      size="small"
      color="primary"
      startIcon={loading ? <CircularProgress size={18} /> : <DownloadIcon />}
      onClick={handleClick}
    >
      EXPORT
    </MuiButton>
  );
};

export default ExportButton;
